import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { requestSynchronization } from '../../../../../../actions/synchronize/synchronize'
import { IStore } from '../../../../../../reducers'
import {
  getLastSyncDate,
  isSyncing,
} from '../../../../../../reducers/synchronize/selectors/lastSync'
import { ISyncDispatch, ISyncProps } from './Synchronization'

const mapStateToProps = (state: IStore): ISyncProps => ({
  isSyncNow: isSyncing(state),
  lastTime: getLastSyncDate(state),
})
const bindDispatchToProps = (dispatch: Dispatch): ISyncDispatch => ({
  fireSync: () => dispatch(requestSynchronization()),
})

export default connect(
  mapStateToProps,
  bindDispatchToProps,
)
